import { render, staticRenderFns } from "./Grupos.vue?vue&type=template&id=50f150b2&scoped=true"
import script from "./Grupos.vue?vue&type=script&lang=js"
export * from "./Grupos.vue?vue&type=script&lang=js"
import style0 from "./Grupos.vue?vue&type=style&index=0&id=50f150b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f150b2",
  null
  
)

export default component.exports